import manager_http from '@/js/http/manager.js';

const SET_TOTAL_USERS = 'setTotalUsers';
const TOTAL_USERS_KEY = 'totalUsers';

let axios = manager_http().axios();

const state = {
  totalUsers: 0,
};

const getters = {
  totalUsers: (state) => state.totalUsers,
};

const mutations = {
  [SET_TOTAL_USERS](state, totalUsers) {
    state.totalUsers = totalUsers;
  },
};

const actions = {
  async fetchDashboardData({ commit }) {
    try {
      const { data } = await axios.get('dashboard');
      commit(SET_TOTAL_USERS, data[TOTAL_USERS_KEY]);
    } catch (error) {
      throw error.response.data;
    }
  },
};

const namespaced = true;

export default { state, getters, mutations, actions, namespaced };
